// first: before any schema is made, zod stops trying eval, which the CSP refuses (v0.15a.3)
import '@dbrain/shared/no-eval';
import '@dbrain/ui/styles.css';
import './app.css';
import './i18n/index.js';
import { applyTheme, readTheme } from '@dbrain/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { AppError, ErrorBoundary } from './components/ErrorBoundary.js';

// the remembered light or dark choice before the first paint
applyTheme(readTheme());

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');
// v0.15a.3: never a white page, whatever fails to draw (the pages have their own boundary inside the router)
createRoot(root).render(
  <StrictMode>
    <ErrorBoundary name="app" fallback={() => <AppError />}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
